import Helper from '@ember/component/helper';
import { service } from '@ember/service';
import { htmlSafe } from '@ember/template';
import dayjs from 'dayjs';
import generateOtaLink from 'frontend-utils/utils/url/generate-ota-link';

export default class OtaRankingLinkHelper extends Helper {
  @service('hotel-and-market') hotelAndMarketService;

  /**
   * @param ota     The OTA on which we want to find the property
   * @param period  The period for which to check (should contain an LOS property on the object)
   * @param hotelInfoId   The id of the hotelInfo. Used to distinguish between primary and secondary brand.com
   * @param persons The amount of persons for which to look
   * @param city    The city in which to search
   * @param value   The actual text for the link
   */
  compute([ota, hotelInfoId, persons, city, value]) {
    // if we don't pass the required fields, return an empty string
    if (!ota) {
      return '';
    }

    const hotelId = this.hotelAndMarketService.hotel?.id;
    const { isTripadvisorRebranding } = this.hotelAndMarketService.hotel;
    const period = {
      fromDate: dayjs(),
      los: 1,
    };

    return htmlSafe(
      `<a target="_blank" href="${generateOtaLink(
        ota,
        hotelInfoId,
        hotelId,
        isTripadvisorRebranding,
        period,
        persons,
        'app_parity',
        city,
      )}&direct=true">${value}</a>`,
    );
  }
}
